import { render, staticRenderFns } from "./SeminarHistory.vue?vue&type=template&id=378d4568&"
import script from "./SeminarHistory.vue?vue&type=script&lang=js&"
export * from "./SeminarHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports